export default function getPersistenceParameters(): Record<
  string,
  string | null
> {
  // Remove `#` (the first symbol) from hash:
  const hashString = location.hash.slice(1);

  // `hashString` is used when loading in an iframe
  // `location.search` is used when loading from URL (mobile SDK)
  const persistenceParameters = new URLSearchParams(
    hashString || location.search,
  );

  const normalizedPersistenceParameters = Array.from(persistenceParameters).map(
    ([key, value]) => [key, value === 'null' ? null : value] as const,
  );

  return Object.fromEntries(normalizedPersistenceParameters);
}
